import { BOTTOM_NAV, LOGIN, NAVIGATION_LIST, APPOINTMENTS, TASKS } from '_constants';
import _ from 'lodash';

export const bottomnav = (state = {}, action) => {
  const newState = _.cloneDeep(state);
  let item = {};
  switch (action.type) {
    case BOTTOM_NAV.UPDATE_ACTIVE_ITEM:
      newState.activeItem = action.activeItem;
      break;
    case APPOINTMENTS.UPDATE_BADGE_COUNT:
      item = newState.items.find(item => item.name === 'Appointments');
      if (item) {
        item.displayCount = action.displayCount;
        item.totalItemsCount = action.totalItemsCount;
      }
      break;
    case TASKS.UPDATE_BADGE_COUNT:
      item = newState.items.find(item => item.name === 'Tasks');
      if (item) {
        item.displayCount = action.displayCount;
        item.totalItemsCount = action.totalItemsCount;
      }
      break;
    case LOGIN.LOGOUT:
      newState.items = NAVIGATION_LIST;
      newState.activeItem = NAVIGATION_LIST[0].name;
      break;
    default:
      break;
  }
  return newState;
};
